module.exports = __webpack_public_path__ + "img/logo-icon-white.c9f90110.svg";